import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import BarChart from "app/components/charts/BarChart";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import RingChart from "./RingChart";

import {
	FormControl,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";

const reorderData = (data) => {

	const colorOrder = [
		"#DE3E40", // American Indian
		"#6AA4DC", // Hispanic
		"#FB6A59", // Asian and Pacific Islander
		"#FFB607", // African American
		"#70898E", // Two or More Races
		"#005898", // White
	];

	const colorToRaceMap = {
	  "#DE3E40": "American Indian",
	  "#6AA4DC": "Hispanic",
	  "#FB6A59": "Asian",
	  "#FFB607": "African American",
	  "#70898E": "Two or More Races",
	  "#005898": "White",
	};

	// Convert the color order to the corresponding race names
	const raceOrder = colorOrder.map(color => colorToRaceMap[color]);

	// Sort the input data based on the race order
	const orderedData = raceOrder.map(race =>
	  data.find(item => item.name === race)
	);

	return orderedData;
  };

class RaceJobCounts extends Component {
  	constructor(props) {
		super(props);
		this.state = {
		}

  	}



  	render() {

		let totalCount = 0;
		this.props.raceData.map(e => {
				totalCount += e.y;
			});
		return (
	  		<div className="graph-wrapper screen-left-graph-container">
				<div className="graph-title-container">
				</div>
				<div className="graph-screen graph-screen3">
                    <div className="graph-title graph-title-2" style={{ marginTop: "30px", marginBottom: "60px", marginLeft: "112px" }}>Race/Ethnicity</div>
                    <RingChart
                    height={"550px"}
                    data={reorderData(this.props.raceData)}
                    tooltipFormatter={
                    function() {
                        const race = this.point.name;
						const value = this.point.y;
						const percent = parseFloat(((value / totalCount) * 100).toFixed(2));
						let tooltip = race + ' : <b>' + value.toLocaleString("en-US") + '</b>' + ' ( ' + percent + '% )';
                        return tooltip;
                    }
                    } />
				</div>
			</div>
		);
  	}
}


export default RaceJobCounts;
